module.exports = __webpack_public_path__ + "static/img/tab-icon.b06e70b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/tab-icon.png
// module id = pigU
// module chunks = 1